export enum PremiumFeature {
	AUTOMATION = 'automation',
	ANALYTICS = 'analytics',
	TEAM_CALENDARS = 'teamCalendars',
	WHITEBOARD = 'whiteboard',
	ADVANCED_PERMISSIONS = 'advancedPermissions',
}

export type PremiumFeatureItem = {
	title: string;
	description: string;
	action: string;
	feature: PremiumFeature;
	icon: any;
	actionLink: string;
	imageLight?: string;
	imageDark?: string;
};
